import { AxiosError } from 'axios';

import useVirtualSession from './useVirtualSession';

const useVirtualSessionPermissions = ({
    eventId,
    sessionId,
    enabled = false,
}: useVirtualSessionPermissionsProps) => {
    const { error } = useVirtualSession({
        eventId,
        sessionId,
        options: {
            enabled: enabled && !!eventId && !!sessionId,
            refetchOnWindowFocus: false,
            notifyOnChangeProps: ['error'],
            retryOnMount: false,
        },
    });

    const parsedError = parseVirtualSessionError(error);

    return parsedError;
};

interface useVirtualSessionPermissionsProps {
    eventId: number;
    sessionId: number;
    enabled?: boolean;
}

export function parseVirtualSessionError(error: AxiosError): ParsedSessionError {
    const hasError = !!error;
    let authorizationType: AuthorizationType | undefined;

    if (!hasError) {
        return {
            hasError,
            authorizationType,
        };
    }

    if (error.response?.data?.includes?.('SESSION_REGISTRATION')) {
        authorizationType = 'SESSION_REGISTRATION';
    }

    if (error.response?.data?.includes?.('TICKET_TYPE')) {
        authorizationType = 'TICKET_TYPE';
    }

    if (error.response?.data?.includes?.('CONTACT_LIST')) {
        authorizationType = 'CONTACT_LIST';
    }

    return {
        hasError,
        authorizationType,
    };
}

export interface ParsedSessionError {
    hasError: boolean;
    authorizationType?: AuthorizationType;
}

type AuthorizationType = 'TICKET_TYPE' | 'CONTACT_LIST' | 'SESSION_REGISTRATION';

export default useVirtualSessionPermissions;
